export default __webpack_public_path__ + "static/media/Confectionery7.6f725ab2.png";